import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

class LanguageSelectionButtons extends React.Component {
  constructor(props) {
    super(props);

    this.clickHandlerEn = this.clickHandlerEn.bind(this);
    this.clickHandlerEs = this.clickHandlerEs.bind(this);
  }

  clickHandlerEn() {
    this.props.chooseLanguage('en');
  }

  clickHandlerEs() {
    this.props.chooseLanguage('es');
  }

  render() {
    return (
      <Fragment>
        <Button className="en" onClick={this.clickHandlerEn}>English</Button>
        <Button className="es" onClick={this.clickHandlerEs}>Español</Button>
      </Fragment>
    );
  }
}

LanguageSelectionButtons.propTypes = {
  chooseLanguage: PropTypes.func.isRequired,
};

export default LanguageSelectionButtons;



// WEBPACK FOOTER //
// ./src/LanguageSelectionButtons.js